import React from "react"
import Logo from "../../assets/logo/SPEDIDAM-LOGO-RVB_Negatif.svg"

const WhiteLogo = () => {
    return(
        <img
            className="portal__item portal__logo"
            src={Logo}
            alt="Logo Spedidam"
        />
    )
}

export default WhiteLogo;